import { selectorFamily } from "recoil"
import { ContactOverviewModel } from "src/types/contact/ContactOverviewModel"
import { ContactFilterValue } from "src/types/contact/ContactFilter"
import { outboxContactsSelectorFamily } from "src/recoil/selectors/contact/outboxContactsSelectorFamily"
import { outboxContactsConcatRequestIdState } from "src/recoil/atoms/contact/outboxContactsConcatRequestIdState"
import { outboxContactFavoriteFlgsCacheState } from "src/recoil/atoms/contact/contactFavoriteFlgsCacheState"

export const outboxContactsConcatSelectorFamily = selectorFamily<
  { contacts: ContactOverviewModel[]; nextToken?: string } | undefined,
  { searchText?: string; filters?: ContactFilterValue[]; count?: number; nextTokens: string[]; organizationId?: string }
>({
  key: "selectors/contact/outboxContactsConcatSelectorFamily",
  get:
    ({ nextTokens, organizationId, ...params }) =>
    async ({ get }) => {
      get(outboxContactsConcatRequestIdState)
      // organizationIdはセレクタのキャッシュキーとして使用（組織切り替え時に再評価させるため）
      // 実際のデータ取得には使用しない（セレクタ内でselectedMyOrganizationSelectorから取得するため）
      void organizationId
      const outboxFavState = get(outboxContactFavoriteFlgsCacheState)
      const result = [
        get(outboxContactsSelectorFamily({ ...params, pageIndex: 0 })),
        ...nextTokens.map((nextToken, index) =>
          get(outboxContactsSelectorFamily({ ...params, nextToken, pageIndex: index + 1 }))
        ),
      ]
      const contactsRes = result.reduce((p, c) => (c != null ? [...p, ...c.contacts] : p), [] as ContactOverviewModel[])
      const contacts = contactsRes.map((c) => {
        if (outboxFavState[c.id] === undefined) {
          return c
        } else {
          return { ...c, isFavorite: outboxFavState[c.id] }
        }
      })
      return {
        contacts,
        nextToken: result.length > 0 ? result[result.length - 1]?.nextToken : undefined,
      }
    },
})
